import { render, staticRenderFns } from "./desuLimitDetail.vue?vue&type=template&id=12f78013&scoped=true"
import script from "./desuLimitDetail.vue?vue&type=script&lang=js"
export * from "./desuLimitDetail.vue?vue&type=script&lang=js"
import style0 from "./desuLimitDetail.vue?vue&type=style&index=0&id=12f78013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f78013",
  null
  
)

export default component.exports